module.exports = __webpack_public_path__ + "static/agua-alta-5fdb19ca1fe16a5aac2e8bb2bb52fa2f.png";